/* Carnistore offers on the product page (snippets/carni-bundle-offers.liquid).
   - Volume tiers set the theme's own quantity box (#Quantity-<section>), so the normal
     Add to cart button stays the one way to buy this item, and the tier matching the
     current quantity is highlighted.
   - Add buttons (pairing, bundle) post to /cart/add.js with the same grouped sections
     the theme's product form asks for, publish cartUpdate so the drawer and header
     count re-render, then open the drawer on desktop only, matching showCartDrawer in
     theme.js (on a phone the theme never opens it after an add).
   Event delegation throughout: product-info.js replaces the block's HTML on every
   variant change. */
(function () {
  if (window.__carniDeals) return;
  window.__carniDeals = 1;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function url(path) { return root.replace(/\/$/, '') + path; }

  function qtyInput(deals) {
    var id = deals && deals.getAttribute('data-section');
    return id ? document.getElementById('Quantity-' + id) : null;
  }

  function syncTiers() {
    document.querySelectorAll('[data-carni-deals]').forEach(function (deals) {
      var input = qtyInput(deals);
      var qty = (input && parseInt(input.value, 10)) || 1;
      var active = null;
      deals.querySelectorAll('[data-carni-tier]').forEach(function (tier) {
        if (qty >= parseInt(tier.getAttribute('data-carni-tier'), 10)) active = tier;
      });
      deals.querySelectorAll('[data-carni-tier]').forEach(function (tier) {
        var on = tier === active;
        tier.classList.toggle('is-active', on);
        tier.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });
  }

  function announce(btn, msg) {
    var deals = btn.closest('[data-carni-deals]');
    var live = deals && deals.querySelector('[data-carni-deals-status]');
    if (live) live.textContent = msg;
  }

  function sectionsToBundle() {
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } }));
    return sections;
  }

  function openDrawer(btn) {
    if (window.FoxTheme && FoxTheme.config && FoxTheme.config.mqlMobile) return;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.show === 'function' && !drawer.open) drawer.show(btn);
  }

  function addToCart(btn) {
    var items = (btn.getAttribute('data-carni-add') || '').split(',').map(function (pair) {
      var p = pair.split(':');
      return { id: Number(p[0]), quantity: Number(p[1]) };
    }).filter(function (i) { return i.id && i.quantity; });
    if (!items.length || btn.disabled) return;

    var label = btn.getAttribute('data-label') || btn.textContent;
    btn.setAttribute('data-label', label);
    btn.disabled = true;
    btn.textContent = 'Adding';

    fetch(url('/cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: sectionsToBundle().join(','), sections_url: window.location.pathname })
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok || j.status) throw j;
          return j;
        });
      })
      .then(function (added) {
        return fetch(url('/cart.js'), { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            cart.sections = added.sections;
            if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
              FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart, source: 'carni-offers' });
            }
            btn.textContent = 'Added';
            btn.classList.add('is-done');
            announce(btn, items.length > 1 ? 'Bundle added to your basket.' : 'Added to your basket.');
            openDrawer(btn);
          });
      })
      .catch(function (err) {
        btn.textContent = 'Could not add';
        announce(btn, (err && (err.description || err.message)) || 'Could not add that. Please try again.');
      })
      .then(function () {
        setTimeout(function () {
          btn.disabled = false;
          btn.classList.remove('is-done');
          btn.textContent = label;
        }, 2200);
      });
  }

  document.addEventListener('click', function (e) {
    var tier = e.target.closest && e.target.closest('[data-carni-tier]');
    if (tier) {
      var input = qtyInput(tier.closest('[data-carni-deals]'));
      if (input) {
        input.value = tier.getAttribute('data-carni-tier');
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      syncTiers();
      return;
    }
    var btn = e.target.closest && e.target.closest('[data-carni-add]');
    if (btn) {
      e.preventDefault();
      addToCart(btn);
    }
  });

  function onQty(e) { if (e.target && e.target.name === 'quantity') syncTiers(); }
  document.addEventListener('change', onQty);
  document.addEventListener('input', onQty);
  document.addEventListener('variant:changed', function () { setTimeout(syncTiers, 0); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncTiers);
  else syncTiers();
})();
